import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { CategoriesCommon } from "../../../../api";

export const categoriesCommonKeys = {
  transportTypes: () => ["transportTypes"]
};

export function useGetTransportTypes(config) {
  const { callApi } = useAuth();
  return useQuery(categoriesCommonKeys.transportTypes(),
    () => callApi(CategoriesCommon.getTransportTypes), config);
}

export function useAttachFileToCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, categoryId, data }) =>
    callApi(CategoriesCommon.attachFileToCategory, { questionnaireId, categoryId, data }), config);
}

export function useGetCategoryAttachment(config) {
  const { callApi } = useAuth();
  return useMutation(({ attachmentId }) =>
    callApi(CategoriesCommon.getCategoryAttachment, { attachmentId }), config);
}

export function useDeleteCategoryAttachment(config) {
  const { callApi } = useAuth();
  return useMutation(({ attachmentId }) =>
    callApi(CategoriesCommon.deleteCategoryAttachment, { attachmentId }), config);
}